import VueI18n from 'vue-i18n'
import Vue from 'vue'
Vue.use(VueI18n)

const messages = {
  en: {
    global: {
      createAccount: 'Create an account',
      login: 'Login',
      questions: 'Questions',
      products: 'Products',
      catalog: 'Catalog',
      concern: 'Concerns',
      service: 'Service',
      title: 'Title',
      subtitle: 'Subtitle',
      description: 'Description',
      shortDescription: 'Short description',
      longDescription: 'Long description',
      benefits: 'Benefits',
      age: 'Age',
      question: 'Question',
      answer: 'Answer',
      close: 'Close',
      cancel: 'Cancel',
      delete: 'Delete',
      save: 'Save',
      search: 'Search',
      noResult: 'No result',
      durationMin: 'Durations (in minutes)',
      image: 'Image',
      send: 'Send',
      areYouSure: 'Are you sure ?',
      selectOneOrMore: 'Please select at least one element',
      services: 'Service'
    },
    questions: {
      yourQuestions: 'Your Questions',
      addQuestion: 'Add a question',
      addAnswer: 'Add an answer',
      editionQuestion: 'Question Edition',
      emptyAnswersDeleted: 'Empty answer will be deleted',
      questionDeleteAsk: 'Do you really want to delete this question ?',
      nextAnswer: 'Next Answer',
      sendQuestion: 'Send the question',
      freeAnswer: 'Free Answer',
      explanation: 'Select each answer by clicking it to edit which concern will be affected',
      titleTooShort: 'Your question is too short,  it must be at least 4 characters long',
      titleTooLong: 'Your question is too long, it must be 100 characters long maximum',
      subtitleTooLong: 'Your Subtitle is too long, it must be 100 characters long maximum',
      noTextAnswer: 'Each answer need to have a text',
      noConcernValue: 'Each concern need a value',
      areYouSure: 'Do you really want to delete this question ?'
    },
    products: {
      yourProducts: 'Your Products',
      productName: 'Product name',
      addProduct: 'Add a product',
      editProduct: 'Edit a product',
      areYouSure: 'Do you really want to delete this product ?'
    },
    catalog: {
      edition: 'Catalog edition',
      selectedElements: 'Selected Element'

    },
    service: {
      title: 'Service Name',
      selectedProducts: 'Selected Products',
      selectedConcerns: 'Selected Concerns',
      edition: 'Service Edition',
      freeAnswer: 'No result',
      areYouSure: 'Do you really want to delete this service ?',
      availableServices: 'Availables Services',
      faceType: 'Face Type'

    },
    concerns: {
      areYouSure: 'Do you really want to delete this concern ?',
      yourConcerns: 'Your concerns'
    },
    catalogs: {
      areYouSure: 'Do you really want to delete this concern ?',
      yourCatalogs: 'Your Catalogs',
      check: 'Check my selection and send',
      send: 'Send the catalog'
    },
    users: {
      add: 'Add User',
      user: 'User',
      users: 'Users'

    }
  },
  fr: {
    global: {
      createAccount: 'Créer un compte',
      login: 'Se connecter',
      questions: 'Questions',
      products: 'Produits',
      catalog: 'Catalogue',
      concern: 'Concerns',
      service: 'Service',
      title: 'Titre',
      subtitle: 'Sous Titre',
      description: 'Description',
      shortDescription: 'Description courte',
      longDescription: 'Description longue',
      benefits: 'Bienfaits',
      age: 'Age',
      question: 'Question',
      answer: 'Réponse',
      close: 'Fermer',
      cancel: 'Annuler',
      delete: 'Supprimer',
      save: 'Sauvegarder',
      search: 'Rechercher',
      noResult: 'Pas de résultat',
      durationMin: 'Durée (en minutes)',
      image: 'Image',
      send: 'Envoyer',
      areYouSure: 'Etes vous sur ?',
      selectOneOrMore: 'Veuillez sélectionner au moins un élement',
      services: 'Service'
    },
    questions: {
      yourQuestions: 'Vos Questions',
      addQuestion: 'Ajouter une question',
      addAnswer: 'Ajouter une réponse',
      editionQuestion: 'Modification de question',
      emptyAnswersDeleted: 'Les réponses vides seront supprimées',
      questionDeleteAsk: 'Voulez vous vraiment supprimer cette question ?',
      nextAnswer: 'Réponse Suivante',
      sendQuestion: 'Valider la question',
      freeAnswer: 'Réponse libre',
      explanation: 'Choisissez quel concern sera affecté par chaque réponse en cliquant dessus.',
      titleTooShort: 'Votre question est trop courte, elle doit faire plus de 4 caractères',
      titleTooLong: 'Votre question est trop longue, elle doit faire moins de 100 caractères',
      subtitleTooLong: 'Votre sous-titre est trop long, il doit faire moins de 100 caractères',
      noTextAnswer: 'Chaque réponse doit avoir une valeur',
      noConcernValue: 'Chaque concern doit avoir une valeur',
      areYouSure: 'Voulez vous vraiment supprimer cette question ?'
    },
    products: {
      yourProducts: 'Vos produits',
      productName: 'Nom du produit',
      addProduct: 'Ajouter un produit',
      editProduct: 'Modifier un produit',
      areYouSure: 'Voulez vous vraiment supprimer ce produit ?'
    },
    catalog: {
      edition: 'Edition du catalogue',
      selectedElements: 'Elements séléctionnés'
    },
    service: {
      title: 'Nom du Service',
      selectedProducts: 'Produits Selectionnés',
      selectedConcerns: 'Concerns Selectionnés',
      freeAnswer: 'Pas de resultat',
      edition: 'Edition des services',
      areYouSure: 'Voulez vous vraiment supprimer ce service ?',
      availableServices: 'Services Disponibles',
      faceType: 'Type de visage'
    },
    concerns: {
      areYouSure: 'Voulez vous supprimer ce concern ?',
      yourConcerns: 'Vos concerns',
      edit: 'Edition de concern'
    },
    catalogs: {
      areYouSure: 'Voulez vous supprimer ce catalogue ?',
      yourCatalogs: 'Vos catalogues',
      check: 'Vérifier la sélection et valider',
      send: 'Envoyer le catalogue'
    },
    users: {
      add: 'Ajouter un utilisateur',
      user: 'Utilisateur',
      users: 'Utilisateurs'

    }
  }
}

const i18n = new VueI18n({
  locale: 'en',
  fallbackLocale: 'en',
  messages
})

export default i18n
